module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-panel-view"
  }, [_c('div', {
    staticClass: "doc-area"
  }, [_c('md-icon', {
    nativeOn: {
      "click": function($event) {
        _vm.$emit('open-menu')
      }
    }
  }, [_vm._v("\n      menu\n      "), _c('md-tooltip', [_vm._v("Меню")])], 1), _vm._v(" "), _c('span', {
    staticClass: "name-content",
    on: {
      "click": function($event) {
        _vm.$emit('rename')
      }
    }
  }, [(_vm.docName !== null) ? [_vm._v("\n        " + _vm._s(_vm.docName) + "\n      ")] : [_vm._v("\n        Несохраненный документ\n      ")]], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "auth-area"
  }, [(_vm.isAuthorized) ? _c('div', {
    staticClass: "login"
  }, [_c('span', {
    staticClass: "login-content"
  }, [_vm._v(_vm._s(_vm.profileName))]), _vm._v(" "), _c('a', {
    staticClass: "link logout",
    on: {
      "click": function($event) {
        _vm.$emit('logout')
      }
    }
  }, [_vm._v("Выйти")])]) : _c('a', {
    staticClass: "link login",
    on: {
      "click": function($event) {
        _vm.$emit('login')
      }
    }
  }, [_vm._v("Войти")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b595b868"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommonPanelView.vue
// module id = 1021
// module chunks = 1